import { render, staticRenderFns } from "./right-menu.vue?vue&type=template&id=5813bddc&scoped=true"
import script from "./right-menu.vue?vue&type=script&lang=js"
export * from "./right-menu.vue?vue&type=script&lang=js"
import style0 from "./right-menu.vue?vue&type=style&index=0&id=5813bddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813bddc",
  null
  
)

export default component.exports